import i from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import s from "../../../rc-util/es/hooks/useEvent.mjs";
import * as a from "react";
import { unstable_batchedUpdates as p } from "react-dom";
import l from "./channelUpdate.mjs";
function v() {
  var t = a.useRef(null), r = function(e) {
    t.current || (t.current = [], l(function() {
      p(function() {
        t.current.forEach(function(n) {
          n();
        }), t.current = null;
      });
    })), t.current.push(e);
  };
  return r;
}
function R(t, r) {
  var u = a.useState(r), e = i(u, 2), n = e[0], f = e[1], c = s(function(o) {
    t(function() {
      f(o);
    });
  });
  return [n, c];
}
export {
  R as default,
  v as useBatcher
};
//# sourceMappingURL=useEffectState.mjs.map
